import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import type { InventoryMainType } from './types.ts'
import { useLoadInventory } from './api.ts'

export const useInventoryMain = defineStore('inventory_main', () => {
  const inventory = ref<InventoryMainType | null>(null)

  /**
   * Функция загрузки данных о группе
   */
  const loadGroupMainData = () => {
    const result = useLoadInventory()

    watch(result.data, () => {
      if (result.data.value) inventory.value = result.data.value.data
    })

    return result
  }

  return {
    inventory,
    loadGroupMainData,
  }
})
